<template>
	<div class="approvecenter">
		<rt-header :title="$_t('审批处理','crm.approvelist')" hide-tag>
			<rt-toolbar show-autoback></rt-toolbar>
		</rt-header>
		<el-tabs type="border-card" :class="approveShowBtn?'approve_card_btn':'approve_card'" v-model="activeName"
			:tab-position="tabPosition" @tab-click="handleClick" :style="{width: approvalWidth}">
			<el-tab-pane name="page">
				<span slot="label">{{$_t('单据详情','approval.formdetail')}}</span>
				<component v-if="!formLogicalName" :is="formCom"></component>
				<vformcore v-else :key="entityId" :objectId="entityId" ref="vformcore" :objectTypeName="entityName"
					:formLogicalName="formLogicalName" :formType="0"></vformcore>
			</el-tab-pane>
			<el-tab-pane :label="$_t('审批信息','approval.approvalinfo')" name="approve">
				<div class="rt-flow-left">
					<rt-flow-approval-list ref="_RTFlowApprovalList" :entityname='entityName' :id='entityId'>
					</rt-flow-approval-list>
				</div>
			</el-tab-pane>

		</el-tabs>

		<div class="approve-box">
			<div class="div_show" v-if="isIfApprove">
				<rc-icon @click="onclickBtn()" :size="17"
					:name="isShowApprove?'rt-saas-fold-show-svg':'rt-saas-fold-hidden-svg'" class="approval-icon"
					color="#4E5969" />
				<!-- <rc-button :plain="false" type="primary"
					:icon-name="isShowApprove? 'rt-saas-angle-play-filled' : 'rt-saas-angle-left-filled'"
					class="btn_show" @click="onclickBtn()">{{isShowText}}
				</rc-button> -->
			</div>
			<transition name="draw">
				<Approve v-show="isShowApprove&&isIfApprove" />
			</transition>
		</div>
	</div>
</template>

<script>
import Approve from "./Approve.vue";
export default {
	components: {
		Approve,
	},
	data() {
		return {
			formCom: null,
			approve: null,
			activeName: "page",
			approveroutename: "Approve",
			routes: [],
			tabPosition: "top",
			hackResetApprove: false,
			hackResetPage: true,
			entityName: this.$route.params.etn,
			entityId: this.$route.params.id,
			approvalWidth: "calc(100% - 310px)",
			isShowApprove: true,
			isShowText: this.$_t("common.collapse", "收起"),
			isIfApprove: this.$route.params.isshowapproval,
			formLogicalName: "",
			approveShowBtn: false
		};
	},
	mounted() {
		this.querySystemParameter();
		this.entityId = this.$route.params.id;
		this.routes = this.$router.options.routes;

		var router = this.$route.params.routerinfo;
		var index = router.indexOf(":");
		// "VForm:LogicalName"
		if (index != -1) {
			var routerArray = router.split(":");
			if (!routerArray[0] || !routerArray[1]) {
				rt.showErrorToast("new_form_router is error,example:VForm:LogicalName");
			} else if (routerArray[0] != "VForm") {
				rt.showErrorToast("new_form_router is error,example:VForm:LogicalName");
			} else {
				this.formLogicalName = routerArray[1];
			}
		}
		if (!this.formLogicalName) {
			this.formCom = this.loadRouteInfo(this.$route.params.routerinfo);
		}

		if (this.isIfApprove == "false" || !this.isIfApprove) {
			this.approvalWidth = "100%";
			this.isIfApprove = false;
		} else {
			this.isIfApprove = true;
		}
	},
	methods: {
		querySystemParameter() {
			rt.get("api/dynamic/new_systemparameter?$select=new_value,new_name&$filter=new_name eq ApproveShowBtn").then(res => {
				if (res && res.Entities && res.Entities.length > 0) {
					this.approveShowBtn = res.Entities[0].new_value.toLowerCase() == "true";
				} else {
					this.approveShowBtn = false;
				}
			}).catch(err => {
				this.approveShowBtn = false;
			});
		},
		onclickBtn() {
			if (this.isShowApprove) {
				this.isShowApprove = false;
				this.approvalWidth = "100%";

			} else {
				this.isShowApprove = true;
				this.approvalWidth = "calc(100% - 302px)";
			}
		},
		handleClick(val) {
			if (val.index === "0") {
				this.hackResetPage = true;
				this.hackResetApprove = false;
			} else {
				this.hackResetPage = false;
				this.hackResetApprove = true;
			}
		},
		loadRouteInfo(routeName) {
			let routeinfo = this.routes.filter((r) => r.name === routeName);
			if (routeinfo.length > 0) {
				return routeinfo[0].component;
			}
			let com = null;
			//不用forEach因为数量太多，结果不可控太消耗内存
			for (var i = 0; i < this.routes.length; i++) {
				var r = this.routes[i];
				if (!r.children) {
					continue;
				}
				var crouteinfo = r.children.filter((cr) => cr.name === routeName);
				if (crouteinfo.length > 0) {
					com = crouteinfo[0].component;
					break;
				}
			}
			return com;
		},
	},
};
</script>

<style scoped lang="less">
.approvecenter {
.rt-content-main {
		padding: 0 !important;
	}
	.approve_card_btn {
		margin-top: 10px;
		box-shadow: none;
		border-bottom: none;
		display: inline-block;
		position: relative;
		float: left;
		transition: all 0.3s ease;
	}

	.approve_card {
		margin-top: 10px;
		box-shadow: none;
		border-bottom: none;
		display: inline-block;
		position: relative;
	}
	.div_show {
		width: 40px;
		height: 32px;
		position: absolute;
		top: 10px;
		right: 0;
		z-index: 999;
		cursor: pointer;
	}

	.btn_show {
		font-size: 14px;
		border-radius: 4px 0px 0px 4px;
	}

	.rt-flow-left {
		width: 100%;
		background-color: #fff;
		z-index: 99;
		padding: 0 22px;
		float: left;
		box-sizing: border-box;
	}

	.Approve {
		// width: 300px;
		float: right;
		background-color: #eeeeee;
	}
	.approve_card_btn {
		 .vform-header .rt-btn-back {
			display: none;
		}
		 & > .el-tabs__content {
			padding: 0;
		}
	}

	 .approve_card > .el-tabs__content {
		padding: 0;
	}
	.approve_card_btn.vform-header .rt-btn-back {
		display: none;
	}

	.approve_card.vform-header {
		display: none;
	}
	.approve-box {
		position: relative;
        float: right;
	}
}
.draw-enter-active {
	transition: all 0.3s ease;
}
.draw-enter {
	width: 0;
	transition: all 0.3s ease;
}
.draw-enter-to {
	width: 300px;
}
// .draw-enter-active,
// .draw-leave-active {
// 	transition: all 0.3s ease;
// 	width: 0;
// }
// .draw-enter,
// .draw-leave-to {
// 	width: 300px;
// }
</style>


// WEBPACK FOOTER //
// ApproveCenter.vue?4d7e574e